import VoiceSlider from "@/pages/VideoClips/MixCutDetail/VideoConfig/VoiceConfig/VoiceSlider/VoiceSlider";
import ConfigStore from '@/stores/mixedConfig/index'
import { observer } from "mobx-react";
import {InputNumber} from "@arco-design/web-react";
import useMixCutDetailSave from "@/useStore/mixCutDetail/useMixCutDetailSave";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import MixedConfig from "@/stores/mixedConfig";
import previewConfing from "@/stores/previewStore";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
const BgBlurConfig = (props) => {
  const { style } = props;
  const { handleBgImagesChange, handleBgChange } = useCoverAndBg();
  const previewHandle = () => {
    const captions = mixCutDetailStore.getProjectCaption();
    const item = captions[0][0];
    mixCutDetailStore.setProjectCaption([
      ...mixCutDetailStore.getProjectCaption(),
    ]);
    MixedConfig.global_settings.captions = [
      ...mixCutDetailStore.getProjectCaption(),
    ];
    previewConfing.setCaption(item, true);
    handleSaveMixCutDetailSave()
  }
  const resetBgColor = () => {
    handleBgImagesChange([]) // 清空背景图片
    handleBgChange(""); // 清空背景颜色
  }
  return (
    <div style={{ padding: '20px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...style }}>
      <VoiceSlider
        style={{ width: 'calc(100% - 100px)' }}
        title={'虚化强度'}
        isZero={false}
        step={1}
        showTicks={true}
        max={100}
        value={ConfigStore.global_settings.background.blur.radius}
        handleSliderChange={(e) => {
          ConfigStore.global_settings.background.blur.radius = e
          // previewHandle()
          resetBgColor()
          handleSaveMixCutDetailSave()
        }}
      />
      <InputNumber
        value={ConfigStore.global_settings.background.blur.radius}
        onChange={(e) => {
          ConfigStore.global_settings.background.blur.radius = e
          // previewHandle()
          resetBgColor()
          handleSaveMixCutDetailSave()
        }}
        style={{ width: 70 }}
        className="font-config-number-input-wrapper"
        min={0}
        max={100}
      ></InputNumber>
    </div>
  )
}
export default observer(BgBlurConfig)
